export type TermsType = 'membership' | 'food'

export const getTermsPath = (locale: string, type: TermsType): string =>
  `/${locale}/${type === 'food' ? 'food/terms' : 'terms'}`

export const getTermsUrl = (locale: string, type: TermsType): string => `https://zoe.com${getTermsPath(locale, type)}`
